/**
 * Created by kirandogra on 20/07/18.
 */
App.controller('addVehicleController',[ '$scope','API','$location','$http','driverService','$mdToast',function( $scope,API,$location,$http,driverService,$mdToast){

    $scope.current_year = (new Date()).getFullYear();
    var toast;
    var driver_info = JSON.parse(localStorage.getItem('driver_info'));

    function getVehicleMakeDetails(){
        var reqObj = {
            city_id: JSON.parse(driver_info.city).city_id,
            vehicle_type: driver_info.vehicle_type
        }
        driverService.getVehicleMakeDetails(reqObj).then(function(res){
            $scope.car_company = res.data.data;

        })
    }
    getVehicleMakeDetails()

    $scope.getModel = function(vehicle_id)
    {
            for(var v in  $scope.car_company )
            {
                if($scope.car_company[v].model_id == vehicle_id)
                    $scope.car_model = $scope.car_company[v];
                    return;
            }

        $scope.car_model = {};
        $scope.car_customization = {};
        $scope.vehicle_model = '';
        $scope.vehicle_colors = {};
        $scope.color_name = '';

    }

    $scope.getCustomizations = function(model){
        try{
            $scope.car_customization =  JSON.parse(model);
            getColorCustomizations();
        }
        catch(err){
            $scope.car_customization = {};
        }
        $scope.vehicle_colors = {};
        $scope.color_name = '';

    }

    function getColorCustomizations(){
        var reqObj = {
            city_id: JSON.parse(driver_info.city).city_id,
            vehicle_type: driver_info.vehicle_type,
            model_id: $scope.car_customization.model_id
        }
        driverService.getVehicleColor(reqObj).then(function(res){
            if(res.data.flag == 143)
              $scope.vehicle_colors = res.data.data;
            else
                createToast('warning','Something went wrong');
        })
    }

    $scope.getVehicleId = function(color_object){
        try{
            $scope.selected_vehicle = JSON.parse(color_object);
        }
        catch(err){
            $scope.selected_vehicle = {};

        }


    }

    $scope.registerVehicle = function(){
        var reqObj = {
            vehicle_make_id: $scope.selected_vehicle.id,
            vehicle_year: $scope.vehicle_year,
            vehicle_type: driver_info.vehicle_type,
            city: JSON.parse(driver_info.city).city_id,
            user_name:  driver_info.name + ' ' +  driver_info.last_name
        }
        driverService.updateDriverInfo(reqObj).then(function(res){
            if(res.data.flag == 143)
            {
                $location.path('/documents');
            }
            else {
                createToast('warning',res.data.error);
            }

        })
        //driverService.registerVehicle(reqObj).then(function(res){
        //    console.log(res);
        //})
    }
    //$scope.backToHomepage = function (){
    //    $('#thankyouModal').modal('hide');
    //    $('body').removeClass('modal-open');
    //    $('.modal-backdrop').remove();
    //    $location.path('/')
    //}
    function createToast(type,content) {
        if(toast)  $mdToast.hide();
        toast = $mdToast.show($mdToast.simple().position('bottom left').textContent(content));
    }
}])